import { createContext } from 'react';
import { AutomaticLogoutContextState } from './model/AutomaticLogoutContextState';

export const AutomaticLogoutContext = createContext(AutomaticLogoutContextState.emptyState);
